export interface FolderViewResponseQuery {
  value: FolderViewResponse[];
}

export interface FolderViewResponse {
  Name: string;
  DocType: string;
  ScopeType: string;
  CreatedOn: string;
  CreatedBy: string;
  ModifiedOn: string;
  ModifiedBy: string;
  id: string;
  QueryGroups: QueryGroup[];
  GroupsInfo: GroupInfo[];
  DisplayColumns: DisplayColumn[];
  Children: FolderViewChild[];
  Owner: string;
  Path: string;
  TenantId: string;
  ParentId?: string;
  SourceViewId?: string;
}

export interface FolderViewSharedWithMeResponse {
  name: string;
  docType: string;
  scopeType: string;
  tenantId: string;
  owner: string;
  path: string;
  sourceViewId: string;
  queryGroups: any[];
  groupsInfo: any[];
  displayColumns: any[];
  sharedWith: any[];
  createdOn: string;
  createdBy: string;
  modifiedOn: string;
  modifiedBy: string;
  id: string;
}

export interface QueryGroup {
  id: string | null;
  relation: string;
  index: number;
  clause: Clause;
  queryGroupInfo: any[];
}

export interface Clause {
  values: string[];
}

export interface GroupInfo {
  startIndex: number;
  endIndex: number;
  level: number;
}

export interface FolderViewChild {
  Id: string;
  FolderViewId: string;
  FolderVwId: string;
  Name: string;
  ParentId: string;
  DocType: string;
  ScopeType: string;
  QueryGroups: QueryGroup[];
  GroupsInfo: GroupInfo[];
  DisplayColumns: DisplayColumn[];
  Children: FolderViewChild[];
}

export interface DisplayColumn {
  InternalName: string;
  DisplayName: string;
  IsDefault: boolean;
  CustomWidth: number;
}

export enum ViewFolderScopeType {
  User = 'User',
  Shared = 'Shared',
  System = 'System',
  SharedWithMe = 'SharedWithMe',
}
